// extracted by mini-css-extract-plugin
module.exports = {"servicesContainer":"Services_servicesContainer__1f_6U","services":"Services_services__WCO8I","title":"Services_title__vrBfi","accordion":"Services_accordion__lnwXH"};